// SEO: URL 언어 prefix 감지 → localStorage 동기화 → BrowserRouter basename 결정
// 다국어 SEO를 위해 /en, /ja, /zh, /es prefix를 진입 시점에 처리.
// 기본 언어(KOR)는 prefix 없이 / 에 매핑되어 기존 URL 호환성 유지.

const STORAGE_KEY = 'vvt_lang';

// URL prefix(소문자) ↔ UI 언어코드(대문자) ↔ BE 언어코드 매핑
export const URL_PREFIX_TO_UI = { en: 'ENG', ja: 'JPN', zh: 'CHN', es: 'SPA' };
export const UI_TO_URL_PREFIX = { KOR: '', ENG: '/en', JPN: '/ja', CHN: '/zh', SPA: '/es' };
export const SUPPORTED_PREFIXES = Object.keys(URL_PREFIX_TO_UI);

function firstSegment(pathname) {
  return (pathname || '/').split('/')[1] || '';
}

/** 현재 URL의 언어 prefix(예: 'en') 또는 '' 반환 */
export function getUrlLangPrefix() {
  const seg = firstSegment(typeof window !== 'undefined' ? window.location.pathname : '/');
  return SUPPORTED_PREFIXES.includes(seg) ? seg : '';
}

/** BrowserRouter에 넘길 basename ('' 또는 '/en' 등) */
export function getBasename() {
  const p = getUrlLangPrefix();
  return p ? `/${p}` : '';
}

// 진입 시점에 URL prefix가 있으면 localStorage를 동기화 → i18n 초기화가 올바른 언어로 시작
try {
  const prefix = getUrlLangPrefix();
  if (prefix) {
    const ui = URL_PREFIX_TO_UI[prefix];
    if (ui) localStorage.setItem(STORAGE_KEY, ui);
  }
} catch {}
